import { Flex, Stack, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import theme from 'theme'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'

type Props = {
  text: string
  icon: IconProp
  isSelected?: boolean
  isDisabled?: boolean
  onClick?: () => void
}

const MenuItem = ({ text, icon, isSelected, isDisabled, onClick }: Props) => {
  return (
    <Stack
      direction="row"
      h="40px"
      spacing="16px"
      align="center"
      borderLeftRadius="20px"
      borderRightRadius="4px"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      background={isSelected ? theme.colors.purple['50'] : theme.colors.white}
      opacity={theme.opacity[isDisabled ? 'disabled' : 'full']}
      _hover={!isSelected && !isDisabled ? { background: theme.colors.gray['50'] } : {}}
      css={
        !isDisabled
          ? {
              '&:hover > .menuItemIconContainer': {
                background: isSelected ? theme.colors.purple['100'] : theme.colors.gray['100'],
              },
            }
          : {}
      }
      {...(onClick && !isDisabled && { onClick: onClick })}
    >
      <Flex
        boxSize="32px"
        borderRadius="full"
        ml="4px"
        align="center"
        justify="center"
        background={isSelected ? theme.colors.purple['100'] : theme.colors.white}
        className="menuItemIconContainer"
      >
        <FontAwesomeIcon
          icon={icon}
          size="sm"
          color={isSelected ? theme.baseColors.secondary.dark : theme.baseColors.text.disabled}
        />
      </Flex>
      <Text
        textStyle={isSelected ? 'body2Bold' : 'body2'}
        color={theme.baseColors.text.default}
        noOfLines={1}
        className="menuItemText"
      >
        {text}
      </Text>
    </Stack>
  )
}

export default MenuItem
